import React from 'react'
import PropTypes from 'prop-types'
import Hidden from '@material-ui/core/Hidden'
import './lang-bar.css'
import HeaderLinks from './header-links/header-links-formatted'
import LangBarBasicComponent from './lang-bar-basic-component'
import { LANGUAGES_BY_BRAND } from '../../../../i18n'
import { makeStyles } from '@material-ui/core'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.secondary.contrastText,
  },
  langBar: {
    backgroundColor: theme.palette.langBar.backgroundColor,
    color: theme.palette.langBar.color,
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    height: 32,
    paddingLeft: '32px',
    paddingRight: '32px',
  },
  headerLinks: {
    float: 'left',
    paddingTop: '0.19rem',
    display: 'flex',
  },
  rightSideLinks: {
    float: 'right',
  },
  headerLinksSecondary: {
    float: 'left',
    paddingTop: '0.19rem',
    marginRight: '0.75rem',
    display: 'flex',
    flexDirection: 'row',
  },
}))

const LangBar = ({ onChangeLanguage }) => {
  const classes = useStyles()
  const brand = useSelector((state) => state.reducer.brand)

  return (
    <Hidden smDown implementation='js'>
      <div className={classes.langBar}>
        <HeaderLinks className={classes.headerLinks} primary />
        {LANGUAGES_BY_BRAND[brand.abbreviation].length > 1 && (
          <div className={classes.rightSideLinks}>
            <LangBarBasicComponent onChangeLanguage={onChangeLanguage} />
          </div>
        )}
      </div>
    </Hidden>
  )
}

LangBar.propTypes = {
  onChangeLanguage: PropTypes.func.isRequired,
}

export default LangBar
